module.exports = __webpack_public_path__ + "media/lesson/fonts/Frutiger/FrutigerBold-c6c19e84c0c70e956020846db0b51d92.ttf";